export const EndorsementLicenceTypeConstants = {
    ADDITIONAL_LICENCE: 'a8a8279d-259c-494b-b057-279506b7ccd7',
    LICENCE_FOR_NEW_FIREARM: 'a07abe24-fc19-446e-bfc3-6d687341a86b',
    RENEWAL_OF_EXISTING_LICENCE: 'f2c82f77-a276-40f2-867a-c579a968bafb'
}